<template>
  <v-fab-transition>
    <v-btn
      style="border-radius: 100% !important"
      class="add-button"
      @click="handleClick"
      fab
      absolute
      left
    >
      <v-icon left dark>mdi-plus</v-icon>
    </v-btn>
  </v-fab-transition>
</template>

<script>
export default {
  methods: {
    handleClick() {
      this.$router.push("/add_event");
    },
  },
};
</script>
